/**
 * 全局常量配置
 */

// 表格配置
export const TABLE_CONFIG = {
  SERIAL_WIDTH: '40px',      // 序号列宽度
  ACTION_WIDTH: '60px',     // 操作列宽度
  PAGE_SIZE: 10,             // 每页显示条数
  PREVIEW_LENGTH: 50         // 列表预览文字长度
};

// API端点
export const API_ENDPOINTS = {
  DIARY_LIST: '/api/MyDiary/List',
  DIARY_GET_BY_ID: '/api/MyDiary/GetById',
  DIARY_DELETE: '/api/MyDiary/Del'
};

// 排序选项
export const SORT_OPTIONS = [
  { value: 'addTime_desc', label: '创建时间（新到旧）' },
  { value: 'addTime_asc', label: '创建时间（旧到新）' },
  { value: 'lastEditTime_desc', label: '修改时间（新到旧）' },
  { value: 'lastEditTime_asc', label: '修改时间（旧到新）' },
  { value: 'title_asc', label: '标题（A-Z）' },
  { value: 'title_desc', label: '标题（Z-A）' }
];

// 消息提示类型
export const TOAST_TYPES = {
  SUCCESS: 'succ',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
};

// 确认对话框配置
export const CONFIRM_CONFIG = {
  DELETE_DIARY: {
    title: '确认删除',
    message: '确定要删除该日记吗？此操作不可恢复。',
    confirmText: '确定',
    cancelText: '取消'
  },
  BATCH_DELETE: {
    title: '确认批量删除',
    message: '确定要删除选中的日记吗？此操作不可恢复。',
    confirmText: '确定',
    cancelText: '取消'
  }
};

